import { AlertCircle, FileText, Upload, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import {
  ADD_INTENTION,
  EDIT_ABONNEMENT,
  LISTE_PARAMETRE_CONFIG,
} from "../../Utils/constant";
import doc from "../../assets/images/demande.png";
import CommuneAutocomplete from "../../components/Widget/CommuneAutoComplete";
import { SubmitButton } from "../../components/Widget/SubmitButton";
import { store, updateOne } from "../../services/service";
import { useConfigStore } from "../../store/ConfigStore";
import { useStoreBatiment } from "../../store/Paramettre/batimentStore";
import { useStoreEquipement } from "../../store/Paramettre/equipementStore";
import { useStoreForfait } from "../../store/Paramettre/forfaitStore";
import { useStoreApp } from "../../store/storeApp";
import { useStoreCommune } from "../../store/storeCommune";
import { useStoreServicePartner } from "../../store/storeServicePartner";

const documentTypes = [
  { label: "CNI du représentant (recto)", value: "CNI_RECTO_REPRESENTANT" },
  { label: "CNI du représentant (verso)", value: "CNI_VERSO_REPRESENTANT" },
  { label: "Statuts de l'entreprise", value: "STATUTS" },
  { label: "Contrat de bail", value: "CONTRAT_BAIL" },
  { label: "Contrat FTTH", value: "CONTRAT_FTTH" },
  { label: "Bon de commande", value: "BON_DE_COMMANDE" },
];

export const formatFileSize = (bytes) => {
  if (bytes < 1024) return bytes + " o";
  if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + " Ko";
  return (bytes / (1024 * 1024)).toFixed(1) + " Mo";
};

export const ModifierAbonnement = () => {
  const [msg, setMsg] = useState("");
  const [typeClient, setTypeClient] = useState(null);
  const [pointServices, setPointService] = useState([]);
  const [postPaidDocuments, setPostPaidDocuments] = useState([]);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const listeServicePartner = useStoreServicePartner();
  const superviseur = useStoreApp();
  const [numeroSuperviseur, setNumeroSuperviseur] = useState("");
  const listeCommune = useStoreCommune();
  const [communeId, setCommuneId] = useState(null);
  const param = useConfigStore();
  const item = JSON.parse(localStorage.getItem("editItem"));
  const isEditing = !!item;
  const {
    register,
    unregister,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);

  const forfaits = useStoreForfait();
  const batiments = useStoreBatiment();
  const typeEquipements = useStoreEquipement();

  const handleAddDocument = (e, documentType) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const newDoc = {
      id: Date.now() + Math.random(),
      type: documentType,
      file: file,
      name: file.name,
      size: file.size,
    };

    setPostPaidDocuments((prev) => [
      ...prev.filter((doc) => doc.type !== documentType),
      newDoc,
    ]);
    e.target.value = null;
  };

  const handleRemoveDocument = (documentId) => {
    setPostPaidDocuments((prev) => prev.filter((d) => d.id !== documentId));
  };

  useEffect(() => {
    if (item) {
      reset({
        nomPrenoms: item?.client?.nomPrenoms,
        email: item?.client?.email,
        contatct: item?.client?.numero,
        secondContact: item?.client?.secondNumero,
        numeroAvantage: item?.numeroMtn,
        typeClient: item?.typeClient,
        equipementId: item?.equipement?.id,
        forfaitId: item?.forfait?.id,
        batimentId: item?.batiment?.id,
        commune: item?.commune,
        quartier: item?.quartier,
      });
    }
  }, [reset, item]);

  useEffect(() => {
    typeEquipements.equipement({ page: 0, param: "", size: 10 });
    batiments.batiments({ page: 0, param: "", size: 10 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submit = (data) => {
    setIsSubmit(true);

    if (data.typeClient === "ENTREPRISE_POSTPAID" && !isEditing) {
      const missingDocumentTypes = documentTypes.filter(
        (docType) =>
          !postPaidDocuments.some((doc) => doc.type === docType.value),
      );

      if (missingDocumentTypes.length > 0) {
        const missingLabels = missingDocumentTypes
          .map((d) => d.label)
          .join(", ");
        toast.error(
          `Veuillez joindre les documents manquants:\n${missingLabels}`,
        );
        setIsSubmit(false);
        return;
      }
    }

    const baseData = {
      ...data,
      statusConfirmation: isEditing ? item?.statusConfirmation : "CONFIRMER",
      contactSuperviseur: numeroSuperviseur,
      communeId: communeId,
      latitude: latitude,
      longitude: longitude,
    };

    if (isEditing) {
      // Mode édition : utiliser updateOne avec JSON
      const payload = {
        ...baseData,
      };

      updateOne(EDIT_ABONNEMENT, item?.id, payload)
        .then((res) => {
          if (res.status === 200) {
            setIsSubmit(null);
            reset();
            toast.success("Intention modifiée");
          }
        })
        .catch((err) => {
          setIsSubmit(false);
          const errorMsg =
            err?.response?.data?.donnee || "Erreur lors de la modification";
          setMsg(errorMsg);
          document.getElementById("errorModal").showModal();
        });
    } else {
      // Mode création : utiliser store avec FormData
      const formData = new FormData();
      Object.keys(baseData).forEach((key) => {
        if (baseData[key] !== undefined && baseData[key] !== null) {
          formData.append(key, baseData[key]);
        }
      });

      postPaidDocuments.forEach((doc, index) => {
        formData.append(`documents[${index}].fichier`, doc.file);
        formData.append(`documents[${index}].typeFichier`, doc.type);
      });

      store(ADD_INTENTION, "multipart/form-data", formData)
        .then((res) => {
          if (res.status === 200) {
            reset();
            setIsSubmit(null);
            setPostPaidDocuments([]);
            toast.success("Intention enregistrée");
            localStorage.setItem(
              "numeroTicket",
              res?.data?.eligibilite?.numeroTicket,
            );
          }
        })
        .catch((err) => {
          setIsSubmit(false);
          setMsg(err?.response?.data?.donnee);
          document.getElementById("errorModal").showModal();
        });
    }
  };

  useEffect(() => {
    param.getData(LISTE_PARAMETRE_CONFIG);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (superviseur?.superviseur?.length === 1) {
      setNumeroSuperviseur(superviseur?.superviseur[0]?.numero);
    }
  }, [superviseur]);

  const totalFichiers = postPaidDocuments.length;
  const typesRenseignes = new Set(postPaidDocuments.map((d) => d.type)).size;

  return (
    <>
      {/* ── Modal erreur intention ── */}
      <dialog id="errorModal" className="modal">
        <div className="modal-box max-w-md bg-white rounded-2xl shadow-2xl">
          <div className="text-center p-6">
            <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
              <AlertCircle className="h-8 w-8 text-red-600" />
            </div>
            <h3 className="text-sm font-mtn font-bold text-gray-900 mb-2">
              Oops! Impossible de faire cette action
            </h3>
            <p className="text-xs text-red-500">{msg}</p>
            <div className="flex items-center justify-center gap-3">
              <button
                onClick={() => document.getElementById("errorModal").close()}
                className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-all duration-200 flex items-center gap-2"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      </dialog>

      {/* ── Modal erreur suppression ── */}
      <dialog id="error" className="modal">
        <div className="modal-box max-w-sm bg-white rounded-2xl shadow-2xl">
          <div className="text-center p-6">
            <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
              <AlertCircle className="h-8 w-8 text-red-600" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Oops! Une erreur s'est produite
            </h3>
            <p className="text-gray-600 mb-6">{msg}</p>
            <div className="flex items-center justify-center gap-3">
              <button
                onClick={() => {
                  document.getElementById("delete").close();
                  document.getElementById("error").close();
                }}
                className="btn-sm rounded-md bg-red-500 text-white"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      </dialog>

      {/* ── Contenu principal ── */}
      {isSubmit === null ? (
        <div className="flex justify-center my-28 w-full">
          <div className="text-center">
            <img className="mx-auto" src={doc} height={80} width={80} alt="" />
            <p className="font-light mt-2 text-sm">
              Intention d'abonnement enregistrée
            </p>
          </div>
        </div>
      ) : (
        <form
          onSubmit={handleSubmit(submit)}
          className="shadow-sm border rounded w-fit lg:w-full p-3"
        >
          <h1 className="text-amber-500 font-mtn text-2xl font-semibold tracking-tight">
            Enregistrer une intention
          </h1>

          <div className="my-3">
            <h2 className="font-medium">Client</h2>
            <hr />
          </div>

          {/* Champs client */}
          <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
            <label className="form-control grid lg:grid-cols-2 md:grid-cols-2 xl:grid-cols-2 grid-cols-1 gap-2 w-full">
              <div>
                <label className="text-sm">
                  Nom et prenoms <span className="text-red-500">*</span>
                </label>
                <input
                  {...register("nomPrenoms", { required: true })}
                  type="text"
                  placeholder="Nom & prénoms"
                  className="input input-bordered w-full h-10 text-sm"
                />
                {errors.nomPrenoms && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              <div>
                <label className="text-sm">Email</label>
                <input
                  {...register("email")}
                  type="email"
                  placeholder="Email"
                  className="input input-bordered w-full h-10 text-sm"
                />
              </div>

              <div>
                <label className="text-sm">
                  Numero Client <span className="text-red-500">*</span>
                </label>
                <input
                  {...register("contatct", { required: true })}
                  type="number"
                  min={0}
                  placeholder="Contact client"
                  className="input input-bordered w-full h-10 text-sm"
                />
                {errors.contatct && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              <div>
                <label className="text-sm">Second contact</label>
                <input
                  {...register("secondContact")}
                  type="number"
                  min={0}
                  placeholder="Second contact client"
                  className="input input-bordered w-full h-10 text-sm"
                />
              </div>

              {param?.data?.CHAMPS_NUMERO_AVANTAGE === "true" ||
              param?.data?.CHAMPS_NUMERO_AVANTAGE === null ? (
                <div>
                  <label className="text-sm">
                    Numero avantage <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    {...register("numeroAvantage", { required: true })}
                    min={0}
                    placeholder="Numero pour les avantages"
                    className="input input-bordered w-full h-10 text-sm"
                  />
                  {errors.numeroAvantage && (
                    <p className="text-red-600 text-xs">Champs obligatoire</p>
                  )}
                </div>
              ) : null}

              <div>
                <label className="text-sm">
                  Type de client <span className="text-red-500">*</span>
                </label>
                <select
                  {...register("typeClient", { required: true })}
                  onChange={(e) => {
                    localStorage.setItem("typeClient", e.target.value);
                    setTypeClient(e.target.value);
                  }}
                  className="select select-bordered w-full h-10"
                >
                  <option value="">type de client</option>
                  <option value="PARTICULIER">Particulier</option>
                  <option value="ENTREPRISE">Entreprise</option>
                  <option value="ENTREPRISE_PREPAID">Entreprise prepaid</option>
                  <option value="ENTREPRISE_POSTPAID">
                    Entreprise postpaid
                  </option>
                </select>
                {errors.typeClient && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              {(typeClient === "ENTREPRISE" ||
                typeClient === "ENTREPRISE_POSTPAID" ||
                typeClient === "ENTREPRISE_PREPAID") && (
                <div>
                  <label className="text-sm">
                    Nom de l'entreprise <span className="text-red-500">*</span>
                  </label>
                  <input
                    {...register("nomEntreprise", { required: true })}
                    type="text"
                    placeholder="Entreprise ...."
                    className="input input-bordered w-full h-10 text-sm"
                  />
                  {errors.nomEntreprise && (
                    <p className="text-red-600 text-xs">Champs obligatoire</p>
                  )}
                </div>
              )}

              <div>
                <label className="text-sm">
                  Type d'équipement <span className="text-red-500">*</span>
                </label>
                <select
                  {...register("equipementId", { required: true })}
                  className="select select-bordered w-full h-10"
                  onChange={(e) => forfaits.forfaitByEquipe(e.target.value)}
                >
                  <option value="" disabled>
                    type d'équipement
                  </option>
                  {typeEquipements?.data?.equipements?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.designation}
                    </option>
                  ))}
                </select>
                {errors.equipementId && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              <div>
                <label className="text-sm">
                  Forfait <span className="text-red-500">*</span>
                </label>
                <select
                  {...register("forfaitId", { required: true })}
                  className="select select-bordered w-full h-10"
                >
                  <option value="">Choisir un forfait</option>
                  {forfaits?.ListForfait?.map((item) => (
                    <option key={item?.id} value={item?.id}>
                      {item?.designation} -{" "}
                      {item?.categorie?.replace("_", " ").toLowerCase()}
                    </option>
                  ))}
                </select>
                {errors.forfaitId && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              <div className="my-2">
                <label className="text-sm">
                  Type de batiment <span className="text-red-500">*</span>
                </label>
                <select
                  {...register("batimentId", { required: true })}
                  className="select select-bordered w-full h-10"
                >
                  <option value="">type de batiment</option>
                  {batiments?.data?.batiments?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.designation}
                    </option>
                  ))}
                </select>
                {errors.batimentId && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              <div className="my-2">
                <label className="text-sm">Point service</label>
                <select
                  value={pointServices?.length > 0 ? pointServices[0]?.id : ""}
                  {...register("pointServiceId")}
                  className="select select-bordered w-full h-10"
                >
                  <option value="">selectionnez un point service</option>
                  {pointServices?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.designation}
                    </option>
                  ))}
                </select>
              </div>

              {superviseur?.superviseur?.length > 1 ? (
                <>
                  <div className="my-2">
                    <label className="text-sm">
                      Superviseur <span className="text-red-500">*</span>
                    </label>
                    <select
                      {...register("nomSuperviseur", { required: true })}
                      onChange={(e) => {
                        setNumeroSuperviseur(
                          superviseur?.superviseur?.find(
                            (item) => item.nomPrenoms === e.target.value,
                          )?.numero,
                        );
                      }}
                      className="select select-bordered w-full h-10"
                    >
                      <option value="">selectionnez un superviseur</option>
                      {superviseur?.superviseur?.map((item) => (
                        <option key={item.nomPrenoms} value={item.nomPrenoms}>
                          {item.nomPrenoms}
                        </option>
                      ))}
                    </select>
                    {errors.nomSuperviseur && (
                      <p className="text-red-600 text-xs">Champs obligatoire</p>
                    )}
                  </div>
                  <div>
                    <label className="text-sm">
                      Contact du superviseur ou de l'agence.{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      placeholder="Contact du superviseur"
                      value={numeroSuperviseur}
                      className="input input-bordered w-full h-10 text-sm"
                      readOnly
                    />
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <label className="text-sm">
                      Nom du superviseur ou de l'agence{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      {...register("nomSuperviseur")}
                      placeholder="Nom du superviseur"
                      defaultValue={superviseur?.superviseur[0]?.nomPrenoms}
                      className="input input-bordered w-full h-10 text-sm"
                      readOnly
                    />
                  </div>
                  <div>
                    <label className="text-sm">
                      Contact du superviseur ou de l'agence.{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      {...register("contactSuperviseur")}
                      placeholder="Contact du superviseur"
                      value={numeroSuperviseur}
                      className="input input-bordered w-full h-10 text-sm"
                      readOnly
                    />
                  </div>
                </>
              )}

              <div>
                <label className="text-sm">
                  Service partner <span className="text-red-500">*</span>
                </label>
                <select
                  value={
                    listeServicePartner?.data?.donnee?.length > 0
                      ? listeServicePartner?.data?.donnee[0]?.id
                      : ""
                  }
                  {...register("servicePartnerId", { required: true })}
                  className="select select-bordered w-full h-10"
                >
                  <option value="">Choisir une service</option>
                  {listeServicePartner?.data?.donnee?.map((item) => (
                    <option key={item?.id} value={item?.id}>
                      {item?.designation}
                    </option>
                  ))}
                </select>
                {errors.servicePartner && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              <CommuneAutocomplete
                setValue={setCommuneId}
                listeCommune={listeCommune}
              />

              <div>
                <label className="text-sm">Quartier</label>
                <input
                  {...register("quartier")}
                  type="text"
                  placeholder="quartier du client"
                  className="input input-bordered w-full h-10 text-sm"
                />
              </div>
            </label>
          </div>

          {typeClient === "ENTREPRISE_POSTPAID" && (
            <div className="mt-6 rounded-xl border border-gray-200 overflow-hidden">
              {/* En-tête */}
              <div className="bg-neutral-50 border-b border-neutral-200 px-5 py-4 flex items-start gap-3">
                <div className="flex-1">
                  <h3 className="text-sm font-semibold text-gray-800">
                    Documents requis — Entreprise postpaid
                  </h3>
                  <p className="text-xs text-gray-500 mt-0.5">
                    Joignez les pièces justificatives · Un fichier par type ·
                    PDF, JPG, PNG
                  </p>
                </div>
                {typesRenseignes > 0 && (
                  <div className="flex-shrink-0 text-right">
                    <span className="inline-flex items-center gap-1 bg-amber-400 text-white text-xs font-semibold px-2.5 py-1 rounded-full">
                      {typesRenseignes} / {documentTypes.length} types
                    </span>
                  </div>
                )}
              </div>

              {/* Grille documents */}
              <div className="p-4 bg-gray-50">
                <div className="my-1">
                  <label className="text-sm">Numero RCCM</label>
                  <input
                    {...register("rccm")}
                    type="text"
                    placeholder="Numero RCCM"
                    className="input input-bordered w-full h-10 text-sm"
                  />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  {documentTypes.map((docType) => {
                    const docsForType = postPaidDocuments.filter(
                      (d) => d.type === docType.value,
                    );
                    const hasFiles = docsForType.length > 0;

                    return (
                      <div
                        key={docType.value}
                        className={`bg-white rounded-lg border transition-all duration-200 overflow-hidden ${
                          hasFiles
                            ? "border-amber-300 shadow-sm"
                            : "border-gray-200"
                        }`}
                      >
                        {/* Titre carte */}
                        <div
                          className={`px-3 py-2 flex items-center justify-between border-b ${hasFiles ? "border-amber-100 bg-amber-50" : "border-gray-100"}`}
                        >
                          <span className="text-xs font-semibold text-gray-700 truncate pr-2">
                            {docType.label}
                          </span>
                          {hasFiles ? (
                            <span className="flex-shrink-0 text-xs bg-amber-100 text-amber-700 font-semibold px-2 py-0.5 rounded-full">
                              {docsForType.length}
                            </span>
                          ) : (
                            <span className="flex-shrink-0 text-xs bg-gray-100 text-gray-400 px-2 py-0.5 rounded-full">
                              Aucun
                            </span>
                          )}
                        </div>

                        <div className="p-3">
                          {/* Document joint */}
                          {hasFiles && (
                            <div className="mb-2">
                              <div className="flex items-center gap-2 bg-gray-50 border border-gray-100 rounded-md px-2 py-1.5">
                                <FileText className="w-3 h-3 text-amber-500 flex-shrink-0" />
                                <span
                                  className="flex-1 text-xs text-gray-700 truncate"
                                  title={docsForType[0].name}
                                >
                                  {docsForType[0].name}
                                </span>
                                <span className="text-xs text-gray-400 flex-shrink-0">
                                  {formatFileSize(docsForType[0].size)}
                                </span>
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleRemoveDocument(docsForType[0].id)
                                  }
                                  className="flex-shrink-0 w-5 h-5 rounded flex items-center justify-center bg-red-50 hover:bg-red-100 transition-colors"
                                >
                                  <X className="w-3 h-3 text-red-500" />
                                </button>
                              </div>
                            </div>
                          )}

                          {/* Bouton upload */}
                          <label className="flex items-center gap-2 w-full px-3 py-2 rounded-md border border-dashed border-gray-300 hover:border-amber-400 hover:bg-amber-50 cursor-pointer transition-all duration-150 group">
                            <Upload className="w-3.5 h-3.5 text-gray-400 group-hover:text-amber-500 flex-shrink-0 transition-colors" />
                            <span className="text-xs text-gray-500 group-hover:text-amber-600 transition-colors">
                              {hasFiles
                                ? "Remplacer le fichier"
                                : "Parcourir un fichier"}
                            </span>
                            <input
                              type="file"
                              className="hidden"
                              accept=".pdf,.jpg,.jpeg,.png"
                              onChange={(e) =>
                                handleAddDocument(e, docType.value)
                              }
                            />
                          </label>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Barre de résumé globale */}
                {typesRenseignes > 0 && (
                  <div className="mt-3 flex items-center gap-4 flex-wrap bg-white border border-gray-200 rounded-lg px-4 py-2.5">
                    <div className="flex items-center gap-1.5">
                      <div className="w-2 h-2 rounded-full bg-amber-400"></div>
                      <span className="text-xs text-gray-500">
                        <strong className="text-gray-700">
                          {typesRenseignes}
                        </strong>
                        {" / "}
                        <strong className="text-gray-700">
                          {documentTypes.length}
                        </strong>{" "}
                        type{typesRenseignes > 1 ? "s" : ""} complét
                        {typesRenseignes > 1 ? "és" : "é"}
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <div className="w-2 h-2 rounded-full bg-gray-300"></div>
                      <span className="text-xs text-gray-500">
                        Taille totale :{" "}
                        <strong className="text-gray-700">
                          {formatFileSize(
                            postPaidDocuments.reduce((s, d) => s + d.size, 0),
                          )}
                        </strong>
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {isSubmit === null ? null : (
            <SubmitButton
              isSubmit={isSubmit}
              label={"Enregistrer l'intention"}
            />
          )}
        </form>
      )}
    </>
  );
};
